import React from 'react';

const ChevronRightIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth="2" strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="m9 18 6-6-6-6"/>
        </svg>

    );
};

export default ChevronRightIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ChevronRightIcon.jsx